module.exports = __webpack_public_path__ + "img/attachment-image.d484b7fa.svg";